import axios from 'axios';

const paymentBaseUrl = process.env.VUE_APP_ANALYTICS_API || '';

const client = axios.create({
  baseURL: paymentBaseUrl,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

export function fetchGhlPaymentOrderData(payload) {
  return client.post('/api/v1/ghl/payment/payments/orderData', payload);
}

export function fetchGhlPaymentInclusions(payload) {
  return client.post('/api/v1/ghl/payment/payments/inclusions', payload);
}

export function submitGhlPaymentCheckout(payload) {
  return client.post('/api/v1/ghl/payment/payments/data', payload);
}

export function fetchGhlPaymentCatalogProduct(locationId, sku) {
  return client.get(`/api/v1/ghl/payment/payments/catalog/${encodeURIComponent(locationId)}/${encodeURIComponent(sku)}`);
}

export function fetchGhlPaymentCatalogList() {
  return client.get('/api/v1/ghl/payment/payments/catalog');
}

export function submitGhlCheckoutLink(payload) {
  return client.post('/api/v1/ghl/payment/payments/checkout-link', payload);
}

export function quoteGhlCheckout(payload) {
  return client.post('/api/v1/ghl/payment/payments/quote', payload);
}

export function fetchGhlPaymentZones(countryId) {
  return client.get(`/api/v1/ghl/payment/payments/zones/${encodeURIComponent(countryId)}`);
}
